export const supportPhoneNumber = '88001002424';

export const genericErrorCode = 0;
export const initErrorCode = -1;
export const inputValidationDebounce = 5; // Seconds

export const errorClockMap: Record<
    number,
    {
        arrowRedAng: number;
        arrowBlueAng?: number;
        message?: string;
        eventName?: string;
        subErrors?: Record<
            number,
            { arrowBlueAng: number; description?: string; eventName?: string }
        >;
    }
> = {
    [genericErrorCode]: {
        arrowRedAng: 270,
    },
    [initErrorCode]: {
        arrowRedAng: 330,
        eventName: 'ERROR_UNKNOWN',
        subErrors: {
            [1]: { arrowBlueAng: 0, eventName: 'SUCCESS_RESPONSE_PARSE' },
            [2]: { arrowBlueAng: 90, eventName: 'ERROR_RESPONSE_INCORRECT' },
            [3]: { arrowBlueAng: 180, eventName: 'ERROR_RESPONSE_PARSE' },
            [4]: { arrowBlueAng: 270, eventName: 'INTERNAL_SERVER_ERROR' },
        },
    },
    [100]: {
        arrowRedAng: 0,
        eventName: 'Нехватка параметров',
    },
    [103]: {
        arrowRedAng: 45,
        eventName: 'Sub_code не предусмотрен',
        subErrors: {
            [1]: { arrowBlueAng: 180, eventName: 'Не задан externalId' },
            [2]: { arrowBlueAng: 210, eventName: 'Не задан токен ВО' },
            [3]: { arrowBlueAng: 240, eventName: 'Не найден указанный канал' },
            [4]: { arrowBlueAng: 0, eventName: 'Не задан LDAP ID' },
            [5]: { arrowBlueAng: 30, eventName: 'Нет данных при запросе в LDAP' },
            [6]: { arrowBlueAng: 60, eventName: 'При запросе данных из LDAP' },
            [7]: { arrowBlueAng: 270, eventName: 'Адаптер ВТБО недоступен' },
            [8]: { arrowBlueAng: 300, eventName: 'В ответе адаптера ВТБО' },
            [9]: { arrowBlueAng: 330, eventName: 'В ответе универсального адаптера' },
            [10]: { arrowBlueAng: 90, eventName: 'Из сервиса кросс. ссылок' },
            [11]: { arrowBlueAng: 120, eventName: 'Из сервиса Карточки ФЛ' },
            [12]: { arrowBlueAng: 150, eventName: 'Резервный код' },
        },
    },
    [401]: {
        arrowRedAng: 45,
        arrowBlueAng: 180,
        eventName: 'Получен просроченный токен JWT',
    },
};

export const clientSendVoiceError = `Запись не удалась. Напишите текстовое сообщение`;

export const globalIntersectionObserverKeyName = '__widget__chat__didSetErrorHandlerRef__';
